import React from 'react';
import { INTENSITY_LABELS } from '../caseTypeConstants';

interface IntensityDotsProps {
    intensity: number;
}

export const IntensityDots: React.FC<IntensityDotsProps> = ({ intensity }) => (
    <div className="flex items-center gap-2">
        {[0, 1, 2, 3].map((dotIndex) => (
            <div
                key={dotIndex}
                className={`w-3 h-3 rounded-full border-2 transition-colors ${
                    dotIndex < intensity
                        ? 'bg-amber-400 border-amber-400'
                        : 'bg-transparent border-gray-300'
                }`}
            />
        ))}
    </div>
);

export const IntensityKey: React.FC = () => (
    <div className="flex items-center w-full px-4 py-3 bg-white rounded-lg border border-gray-200">
        <div className="flex items-center justify-evenly flex-1 ml-8 mr-8">
            {INTENSITY_LABELS.map(({ value, label }) => (
                <div key={value} className="flex items-center gap-3">
                    <IntensityDots intensity={value} />
                    <span className="text-sm font-semibold text-[#6B7280]">{label}</span>
                </div>
            ))}
        </div>
    </div>
);
